import { get, patch } from './index';

export const getModelForm = async (name, organizationId) => {
  return get(`/api/v2/model_forms/${name}?organization_id=${organizationId}`);
};

export const reorderCustomFields = async (name, organizationId, formItems) => {
  return patch(`/api/v2/model_forms/${name}/reorder`, {
    organization_id: organizationId,
    form_items: formItems.map(({ id, position }) => ({ id, position })),
  });
};
